import { FeatureFlagKey } from "@/types/feature-flags";
import { featureFlagManager } from "@/lib/feature-flags/manager";

/**
 * Simple hook to check if a feature flag is enabled
 * This hook does NOT subscribe to changes and is safe to use without causing re-renders
 * Use this when you just need to check a flag value without subscribing to updates
 */
export const useFeatureFlag = (flagKey: FeatureFlagKey): boolean => {
  return featureFlagManager.isEnabled(flagKey);
};

/**
 * Hook to get feature flag details
 * This hook does NOT subscribe to changes and is safe to use without causing re-renders
 */
export const useFeatureFlagDetails = (flagKey: FeatureFlagKey) => {
  return featureFlagManager.getFlag(flagKey);
};

/**
 * Hook to get all feature flags
 * This hook does NOT subscribe to changes and is safe to use without causing re-renders
 */
export const useAllFeatureFlags = () => {
  return featureFlagManager.getAllFlags();
};

/**
 * Hook to get the current environment
 */
export const useFeatureFlagEnvironment = () => {
  return featureFlagManager.getCurrentEnvironment();
};

/**
 * Hook to get the current account ID
 */
export const useFeatureFlagAccountId = () => {
  return featureFlagManager.getCurrentAccountId();
};

/**
 * Hook to set the account ID for account-specific overrides
 */
export const useSetFeatureFlagAccountId = () => {
  return {
    setAccountId: (accountId: number) =>
      featureFlagManager.setAccountId(accountId),
    clearAccountId: () => featureFlagManager.clearAccountId(),
  };
};
